import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import {
    fetchingFlashMessages,
    hideFlashMessage,
    hideHeaderFlashMessage,
    showFlashMessage,
    showHeaderFlashMessage,
    showHeaderNotificationAction,
    hideHeaderNotificationAction,
    showNotification,
    hideNotification,
} from './actions';

const reducer = reducerWithInitialState(initialState)
    .case(showFlashMessage, (state, payload) => ({
        ...state,
        flashMessages: [
            ...state.flashMessages,
            {
                ...payload,
                seen: true,
            },
        ],
    }))
    .case(hideFlashMessage, state => ({
        ...state,
        flashMessages: [],
    }))
    .case(showHeaderFlashMessage, (state, payload) => ({
        ...state,
        displayHeaderFlashMessage: true,
        headerFlashMessage: {
            type: payload.type === 'success' || payload.type === 'info' ? 'success' : 'error',
            message: payload.message || '',
            action: !!payload.callbackText &&
                !!payload.clickCallback && {
                    text: payload.callbackText,
                    callback: payload.clickCallback,
                },
        },
    }))
    .case(hideHeaderFlashMessage, state => ({
        ...state,
        displayHeaderFlashMessage: false,
        headerFlashMessage: null,
    }))
    .case(fetchingFlashMessages.started, state => ({
        ...state,
        headerFlashMessage: null,
    }))
    .case(fetchingFlashMessages.failed, (state, payload) => ({
        ...state,
        errors: [...state.errors, payload.error],
    }))
    .case(showHeaderNotificationAction, (state, payload) => ({
        ...state,
        headerNotificationBanner: payload.notification,
    }))
    .case(hideHeaderNotificationAction, state => ({
        ...state,
        headerNotificationBanner: null,
    }))
    .case(showNotification, state => ({
        ...state,
        showNotification: true,
    }))
    .case(hideNotification, state => ({
        ...state,
        showNotification: false,
    }));

export default reducer;
